import faviconImage from '@/assets/img/favicon.png';
import connectionLost from '@/assets/img/weon-alert-favicon.png';

const faviconElement = document.createElement('link');
// const faviconElement = document.createElement('favicon')

faviconElement.rel = 'shortcut icon';
faviconElement.type = 'image/png';
faviconElement.href = faviconImage;

document.head.appendChild(faviconElement);

export const setFavIconByStatus = async (status = 'default') => {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  if (status == 'default') {
    link.href = faviconImage;
    document.title = 'WeON Attendance WEB';
  } else {
    link.href = connectionLost;
    document.title = 'Voz desconectada | WeON';
  }
};
